import {BrowserRouter as Router,Switch,Route} from 'react-router-dom'
import './App.css';
import ShibuCord_main from './ShibuCord_main';
import SignIn from './SignIn';
import { useStateValue } from './StateProvider';
import React, {useEffect} from 'react';
import { auth } from './firebase';
function App() {
  const [{},dispatch] = useStateValue();
  useEffect(() => {
    auth.onAuthStateChanged((authUser)=>{
      console.log("User is>" , authUser);
      if(authUser){
        dispatch({
          type:'SET_USER',
          user:authUser,
        });
      }
      else{
        dispatch({
          type:'SET_USER',
          user:null,
        });

      }
    })
  }, [])

  return (
    <Router>

    
    <div className="app">
      <Switch>
       
        <Route path="/shibuCord">
      <ShibuCord_main />
        </Route>
       <Route path="/">
      <SignIn />
        </Route>
      </Switch>
      
     
    </div>
     </Router>
  );
 
}

export default App;
